export const SEARCH_MODE_DEFAULT = 'default';
export const SEARCH_MODE_MANUAL_LIST = 'manual-list-membership';

export const MIN_QUERY_LENGTH = 2;
export const SEARCH_DEBOUNCE_MS = 250;

export const MESSAGE_MIN_QUERY = 'Type at least 2 characters to search.';
export const MESSAGE_TEMPORARY_ERROR = 'Search is temporarily unavailable.';
export const MESSAGE_BLOCKED = 'Manual game creation is blocked.';

export const MESSAGE_SEARCHING = 'Searching...';
export const MESSAGE_EXTERNAL_UNAVAILABLE = 'IGDB is unavailable for this search.';
export const MESSAGE_LOAD_MORE = 'Load more';
export const MESSAGE_LOAD_MORE_LOADING = 'Loading...';
export const MESSAGE_LOAD_MORE_FAILED = 'Could not load more results from IGDB.';

export const MESSAGE_MANUAL_SECURITY_TOKEN_MISSING = 'Security token is missing. Refresh the page and try again.';
export const MESSAGE_MANUAL_TOGGLE_FAILED = 'Failed to update manual list membership.';
export const MESSAGE_MANUAL_GAME_ADDED = 'Game added to this list.';
export const MESSAGE_MANUAL_GAME_REMOVED = 'Game removed from this list.';

export const MESSAGE_MANUAL_LIST_RESULTS_HINT = 'Click a game to add or remove it from this list.';

export const MESSAGE_NO_RESULTS = 'No results.';
